import { call, fork } from 'redux-saga/effects';
import { getGrowthBook } from '../../../services/growthbook';
import FEATURES, { DEFAULT_VALUES } from '../../../constants/featureToggling';
import { initSentry } from '../../../services/sentry';

export function checkIsSentryAllowed() {
  const isSentryAllowed = getGrowthBook()?.getFeatureValue?.(
    FEATURES.SENTRY,
    DEFAULT_VALUES.SENTRY
  );

  return isSentryAllowed;
}

export function* commonSentry() {
  const isSentryAllowed = yield call(checkIsSentryAllowed);

  if (isSentryAllowed) {
    yield fork(initSentry);
  }
}
